<section class="content">
  <div class="card" style="padding:25px">

    <div class="container-fluid">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
      <!-- <div class="block-header"> -->
      <!-- <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <ul class="breadcrumb breadcrumb-style ">
                        <li class="breadcrumb-item">
                            <h4 class="page-title">Basic Form</h4>
                        </li>
                        <li class="breadcrumb-item bcrumb-1">
                            <a routerLink="/dashboard/main">
                                <i class="fas fa-home"></i> Home</a>
                        </li>
                        <li class="breadcrumb-item bcrumb-2">
                            <a href="#" onClick="return false;">Forms</a>
                        </li>
                        <li class="breadcrumb-item active">Basic</li>
                    </ul>
                </div>
            </div> -->
      <!-- </div> -->
      <!-- <app-maser-page-header></app-maser-page-header> -->
      <br>

      <div class="form-row">
        <div class="col-2" style="border: 1px solid grey; border-radius: 8px; margin-left: 18 px;">
          <input type="text" style="border: none; margin-left: 11px; margin-top: 4px;" class="form-control"
            [(ngModel)]="booth_code" placeholder="Booth Code" (keydown.enter)="checkBoothExists()">
        </div>
        <div class="col-1 text-center" style="font-size: 23px;color: lightslategrey;">or</div>
        <div class="col-2" style="border: 1px solid grey; border-radius: 8px">
          <input type="text" class="form-control" [(ngModel)]="agent_code" (keydown.enter)="checkBoothExists()"
            style="border: none; margin-left: 11px; margin-top: 4px;" placeholder="Agent code">
        </div>
        <div class="col">
          <button mat-raised-button color="primary" (click)="checkBoothExists()"
            style="margin-top: 7px; margin-left: 18px;">Confirm
          </button>
        </div>
      </div>
      <div *ngIf="business_available">
        <div class="card"
          style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px;font-size: 15px; width: 70%; margin-top: 18px;">
          <div class="row">
            <div class="col-1"></div>
            <div class="col text-center">
              <h4 style="font-weight: normal;">Agent Details</h4>
            </div>
            <div class="col-2"></div>
          </div>
          <div class="row" style="padding: 10px;">
            <!-- <div class="col-1"></div> -->
            <div class="col">
              <b>Agent Name : </b> {{business_details['agent_name'] }}
            </div>
            <div class="col">
              <b>Agent Code : </b> {{business_details['agent_code'] }}
            </div>
            <div class="col">
              <b>Booth Code :</b> {{business_details['booth_code']}}
            </div>
          </div>
          <div class="row" style="padding: 10px;">
            <!-- <div class="col-1"></div> -->
            <div class="col">
              <b>Booth zone :</b> {{ business_details['booth_zone']}}
            </div>
            <div class="col">
              <b>Agent Mobile :</b> {{ business_details['agent_mobile']}}
            </div>
            <div class="col">
              <b>Booth address :</b> {{business_details['booth_address']}}
            </div>
          </div>
        </div>
        <div class="card" [style.border-left]="checkBorderColor(log['transaction_status_id'])"
          *ngFor="let log of transaction_log; let odd_index=odd" style="padding: 26px; width: 50%;">
          <div class="row">
            <div class="col" style="font-size:15px">
              <span *ngIf="log['transaction_direction_id'] == 1 "
                style="font-weight: bold; font-size: initial;">Payment</span>
              <span *ngIf="log['transaction_direction_id'] == 2 "
                style="font-weight: bold; font-size: initial;">Payment</span>
              <span *ngIf="log['transaction_direction_id'] == 3 "
                style="font-weight: bold; font-size: initial;">Refund</span>
              <span style="margin-left: 22px;">{{log['transaction_direction_description']}}</span>
            </div>
            <div class="col-5" style="text-align: right;">
              Amount : {{log['amount'] | currency:'INR'}} <br>
            </div>
          </div>
          <div class="row">
            <div class="col-4" style="text-align: left; font-size: 12px;">
              {{log['time_created'] | date:'MMM d, h:mm a'}}
            </div>
            <div class="col" style="text-align: right;">
              Wallet balance : {{ log['wallet_balance_after'] | currency:'INR'}}
            </div>
          </div>
          <div class="row">
            <div class="col-4" style="text-align: left; font-size: 12px;">
              payment Mode : {{log['transaction_mode_name']}}
            </div>
            <div class="col" style="text-align: right; font-size: 12px;" *ngIf="log['transaction_mode'] == 3">
              <span *ngIf="log['transaction_status_id'] == 2">Transaction id :
                {{ log['transaction_id']}}</span>
              <span *ngIf="log['transaction_status_id'] == 1"><button mat-stroked-button color="primary"
                  (click)="getChequeApprovalStatus(log.id)">Approve</button></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
